import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import SettingsStore from "SettingsStore";
import ThemeType from "ThemeType";
import ScrollBar from "ScrollBar";

import {
  updateSelectedPortfolioId,
  toggleTransactionsVisible,
  toggleShadingVisible,
  setTransactionOpacity
} from "../../../../Actions/RelatedInfoPanelActions/RiPanelActions";
import { updateChartOnStreaming } from "../../../../Actions/PricePanelActions";

const RiPanelTransactionInfo = ({
  userPortfolios,
  selectedPortfolios,
  tranOpacity,
  setTransactionOpacity,
  isTransactionsVisible,
  isRoundtripShadingVisible,
  toggleShadingVisible,
  updateChartOnStreaming,
  updateSelectedPortfolioId,
  toggleTransactionsVisible,
  loading,
  priceDataAvailable,
}) => {
  const [sliderValue, setSliderValue] = useState(Math.round(tranOpacity * 100) ?? 100);


  useEffect(() => {
    if (tranOpacity != null) {
      setSliderValue(Math.round(tranOpacity * 100));
    }
  }, [tranOpacity]);

  const handleSliderChange = (value) => {
    setSliderValue(value)
    setTransactionOpacity(value / 100);
    updateChartOnStreaming();
  }

  const getImgTheme = () => {
    return SettingsStore.getConsoleSettings().currentTheme === ThemeType.Dark ? "dk" : "lt";
  }
 
  return (
    <>
      {loading ? (
        <div className="transaction-loading"><p>Loading Transactions...</p></div>
      ) : (
        !priceDataAvailable ? ( 
          <div className="transaction-loading"><p>No Data Available</p></div>
        ) : (
      <div className="transaction-container custom-scroll">
        <div id="transactionsCustomScroll">
                  {!userPortfolios || userPortfolios.length === 0 ? (
            <div className="no-transactions">
              <h4>PANARAY TRANSACTIONS</h4>
              <span className="img-title">Buys and Sells</span>
              <img
                src={`../Asset/images/transaction-flags-${getImgTheme()}.png`}
                alt="No Transactions"
              />
              <p className="img-info">Available on all chart intervals</p>
              <span className="img-title">Average cost and roundtrip data</span>
              <img
                src={`../Asset/images/roundtrip-shading-${getImgTheme()}.png`}
                alt="No Transactions"
              />
              <p className="img-info">To view <i>Max % of Portfolio, %G/L and Average Cost</i>(dotted line), simply include this data in your transaction file upload</p>
            </div>
          ) : (
            <div className="transaction-innerBlock">
              <span className="title">
                Transactions
              </span>
              <div className="toggle-section">
                <div className="on-off-switch">
                  <label className="switch" onClick={() => toggleTransactionsVisible()}>
                    <div
                      className={isTransactionsVisible ? "toggle-switch active" : "toggle-switch"}
                      id="toggleSwitch"
                    >
                      <div className="switch-circle"></div>
                      <span className="toggle-text off">OFF</span>
                      <span className="toggle-text on">ON</span>
                    </div>
                  </label>
                </div>
                <input
                  type="checkbox"
                  id="roundtrip-shading"
                  onKeyDown={(e) => {
                    if (e.code === 'Space' || e.key === ' ') {
                      e.preventDefault(); // prevents toggling
                    }
                  }}
                  onChange={toggleShadingVisible}
                  checked={isRoundtripShadingVisible}
                  disabled={!isTransactionsVisible}
                />
                <label htmlFor="roundtrip-shading" className={!isTransactionsVisible ? "disabled-label" : ""}>
                  <span>Roundtrip shading</span>
                </label>
              </div>
              <div className={`slider-container ${!isTransactionsVisible ? "disabled-text" : ""}`}>
                <span className="title">
                  Price bar opacity
                </span>
                <div className="slider">
                  <span style={{ minWidth: '30px' }} className="slider-value">0%</span>
                  <input
                    type="range"
                    min="0"
                    max="100"
                    // defaultValue={sliderValue}
                    value={sliderValue}
                    onKeyDown={(e) => {
                        if (e.code === 'Space' || e.key === ' ') {
                          e.target.blur(); // removes focus
                          e.preventDefault(); // prevents toggling
                        }
                      }}
                    onChange={(e) => handleSliderChange(e.target.value)}
                    className="range-slider"
                    disabled={!isTransactionsVisible}
                  />
                  <span style={{ minWidth: '40px' }} className="slider-value">{sliderValue}%</span>
                </div>
              </div>
              <div className="horizontal-divider"></div>
              <h4 className={`${!isTransactionsVisible ? "disabled-text" : ""}`}>Accounts</h4>
              <ul>
                {userPortfolios.map((portfolio) => (
                  <li key={portfolio.portfolioid} className="portfolio-list">
                    <input
                      type="checkbox"
                      id={`checkbox-${portfolio.portfolioid}`}
                      checked={selectedPortfolios?.includes(portfolio.portfolioid) ?? false}
                      onKeyDown={(e) => {
                        if (e.code === 'Space' || e.key === ' ') {
                          e.target.blur(); // removes focus
                          e.preventDefault(); // prevents toggling
                        }
                      }}
                      onChange={() => updateSelectedPortfolioId(portfolio.portfolioid)}
                      disabled={!isTransactionsVisible}
                    />
                    <label htmlFor={`checkbox-${portfolio.portfolioid}`} className={!isTransactionsVisible ? "disabled-label" : ""}>
                      {portfolio.portfolioname}
                    </label>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>
        ))}
      <ScrollBar scrollId="transactionsCustomScroll" vScroll={true} />
    </>
  );
};

const mapStateToProps = ({ RelatedInfoPanelReducers, appColor, DatagraphReducers }) => {
  const { userPortfolios, transactionsSettings, loading } = RelatedInfoPanelReducers.RiPanelTransactionsReducer;
  const { isTransactionsVisible, isRoundtripShadingVisible, selectedPortfolios, tranOpacity } = transactionsSettings;
  const { isThemeChanged } = appColor;
  const { priceDataAvailable } = DatagraphReducers.DataGraphReducer
  return { userPortfolios, selectedPortfolios, tranOpacity, isTransactionsVisible, isRoundtripShadingVisible, loading, isThemeChanged, priceDataAvailable };
};

const mapDispatchToProps = (dispatch) => ({
  setTransactionOpacity: (tranOpacity) => dispatch(setTransactionOpacity(tranOpacity)),
  updateSelectedPortfolioId: (portfolioId) => dispatch(updateSelectedPortfolioId(portfolioId)),
  toggleTransactionsVisible: () => dispatch(toggleTransactionsVisible()),
  toggleShadingVisible: () => dispatch(toggleShadingVisible()),
  updateChartOnStreaming: (portfolioIds) => dispatch(updateChartOnStreaming(portfolioIds)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RiPanelTransactionInfo);
